import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleSquareOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M4.667 6.3h6.666V4.9H4.667z" fill="currentColor" />
                <path d="M10 7.567H4.667v1.4H10z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.501 6.635v.003L.5 6.636V15.5l4.194-2.176c.901.098 1.99.13 3.306.13 6.563 0 7.5-.81 7.5-6.477S14.563.5 8 .5C2.479.5.94 1.073.59 4.63A23 23 0 0 0 .5 6.635M1.9 13.197v-6.39l.001-.159c.01-1.321.082-2.238.244-2.898.153-.624.362-.918.591-1.104.26-.21.714-.419 1.602-.558C5.225 1.95 6.402 1.9 8 1.9c1.632 0 2.824.052 3.716.197.89.145 1.331.36 1.58.576.225.195.437.513.587 1.2.156.715.217 1.7.217 3.104s-.06 2.39-.217 3.105c-.15.687-.362 1.005-.587 1.2-.249.215-.69.43-1.58.576-.892.145-2.084.197-3.716.197-1.302 0-2.33-.033-3.155-.123l-.42-.045z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BubbleSquareOutlinedSize16Glyph.displayName = 'BubbleSquareOutlinedSize16Glyph';
